import { Turbo } from '@hotwired/turbo-rails';

// Make Turbo Drive opt-in
Turbo.session.drive = false;
